import { useTableFilter } from "@/shared";
import { useFetchConfigComision } from "@/shared/actions/erp/comision/configuracion-comision.actions";
import { CustomSearch, GeneralTable, SingleTableBoxScene } from "@/shared/components/ui";
import { useTableColumnsComision } from "@/shared/hooks/useTableColumnsComision";
import { IConfigComisionesData } from "@/shared/interfaces/erp/comision/comision.interface";
import { Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";


export default function ComisionPage() {


  const navigate = useNavigate();

  ///* table
  const {
    globalFilter,
    pagination,
    onChangeFilter,
    setPagination,
    cleanFilter
  } = useTableFilter();
  const { pageIndex, pageSize } = pagination;

  const { data: dataConfigComision, isLoading: isLoadingComision, isRefetching } = useFetchConfigComision({
    page: pageIndex + 1,
    page_size: pageSize,

  });


  const { columnBase } = useTableColumnsComision();

  return (
    <SingleTableBoxScene
      title="Configuración Comisión"
      enableRedirect={true}
      urlRedirect={'/parametrizacion/comicion-configuracion/crear'}

    >

      <Grid container spacing={3}>

        <Grid item xs={12}>
          <CustomSearch
            onChange={onChangeFilter}
            value={globalFilter}
            cleanFilter={cleanFilter}
            text=""

          />
        </Grid>

        <Grid item xs={12}>
          <GeneralTable<IConfigComisionesData>
            columns={columnBase}
            data={dataConfigComision?.data || []}
            //
            isLoading={isLoadingComision}
            isRefetching={isRefetching}
            // // search
            enableGlobalFilter={false}
            // onGlobalFilterChange={setGlobalFilter}
            // // pagination
            pagination={pagination}
            onPaging={setPagination}
            rowCount={dataConfigComision?.count}
            // // actions
            actionsColumnSize={120}
            // crud
            canDelete={false}
            positionActionsColumn='first'

            //
            enableColumnActions={true}
            enableEditing={true}
            onEdit={(e) => {
              navigate(`/parametrizacion/comicion-configuracion/editar/${e.id_configuracion_comiciones}`)       
        }}

          />
        </Grid>

      </Grid>
    </SingleTableBoxScene>
  )

}